import { FormConfig } from 'stories/forms/FormBuilder/FormBuilder.types';
import { LearnMoreContentData } from '@act/shared/data-transfer-objects';
import { SurveyAdmin } from '@act/shared/data-transfer-objects';

export const createLearnMoreFormConfig = (
  allLearnMoreRecords: SurveyAdmin.LearnMoreCreatorRecordDto[]
): FormConfig<LearnMoreContentData> => {
  const config: FormConfig<LearnMoreContentData> = [
    {
      type: 'input',
      name: 'title',
      label: 'Content Title',
      input: 'text',
      props: {
        required: true,
        placeholder: 'Enter content title',
      },
    },
  ];

  if (allLearnMoreRecords?.length > 0) {
    config.unshift({
      type: 'input',
      name: 'selectedLearnMoreRecordId',
      label: 'Choose a record to edit',
      input: 'select',
      props: {
        fullWidth: true,
        options: [
          {
            label: 'Select a record to edit',
            value: -1,
          },
          ...allLearnMoreRecords.map(record => ({
            label: record.learnMoreContent.title,
            value: record.id,
          })),
        ],
      },
    });
  }

  return config;
};
